import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fieldsToShow"]


  connect() {
    this.toggleFieldsVisibility()
  }

  toggleFieldsVisibility() {
    const select = this.element.querySelector('#integration_provider')
    const providerValue = select?.value || this.providerValue || ''
    const hasProvider = providerValue && providerValue !== '' && providerValue !== 'Select Provider'
    
    this.fieldsToShowTargets.forEach(field => {
      if (hasProvider) {
        field.classList.remove('hidden')
      } else {
        field.classList.add('hidden')
      }
    })
  }
}

